import React, { useContext } from 'react';

// Keep track of the Browser's true dimensions
export const BrowserDimensionsContext = React.createContext({ isDesktop: true, width: 600, height: 400 });

export const useIsDesktop = () => {
  const { isDesktop } = useContext(BrowserDimensionsContext);
  return isDesktop;
};

export const useDimensions = () => {
  const dims = useContext(BrowserDimensionsContext);
  return { ...dims };
};
